import Swal from 'sweetalert2'

export const showErrorAlert = async () => {
  await Swal.fire({
    title: 'Não foi possivel obter os agendamentos, tente novamente mais tarde',
    icon: 'error',
    showCancelButton: false,
    confirmButtonText: 'Ok',
    customClass: {
      confirmButton: 'btn btn-danger',
      cancelButton: 'btn btn-secondary',
    },
  })
}
